const SLOT_RE = /^(\d{2}):(\d{2})-(\d{2}):(\d{2})$/;

/** Same IST slot/grace boundary for the server and cached gate admission. Null/non-time labels mean any time. */
export function slotOpen(slot: string | null, at: Date, graceMinutes: number): boolean {
  const m = slot ? SLOT_RE.exec(slot) : null;
  if (!m) return true;
  const start = Number(m[1]) * 60 + Number(m[2]);
  const end = Number(m[3]) * 60 + Number(m[4]);
  const [h, min] = at.toLocaleTimeString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: false }).split(":").map(Number);
  const now = h! * 60 + min!;
  return now >= start - graceMinutes && now <= end + graceMinutes;
}
